import getAnyOrNull from 'utils/accessors/getAnyOrNull.util';
import nullBind from 'utils/functions/nullBind.util';

const getLockToken = nullBind(getAnyOrNull, 'lockToken');
const getParsedToken = nullBind(getAnyOrNull, 'parsedToken');

const reduceUiLockUpdate = (state, locked) => ({
  ...state,
  locked,
  lockToken: locked ? null : getLockToken(state),
  parsedToken: locked ? null : getParsedToken(state),
});

// noinspection JSUnusedGlobalSymbols
export default reduceUiLockUpdate;
